(() => {
  const panel = document.querySelector('[data-ida-account-panel]');
  if (!panel) return;

  const triggers = Array.from(document.querySelectorAll('[data-ida-account-open]'));
  const closeButtons = Array.from(panel.querySelectorAll('[data-ida-account-close]'));
  const form = panel.querySelector('[data-ida-account-form]');
  const email = panel.querySelector('[data-ida-account-email]');
  const status = panel.querySelector('[data-ida-account-status]');
  let lastFocused = null;

  const setTriggerState = (expanded) => {
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
  };

  const open = (event) => {
    if (event) event.preventDefault();
    lastFocused = document.activeElement;
    panel.hidden = false;
    document.body.classList.add('ida-account-open');
    setTriggerState(true);
    window.requestAnimationFrame(() => email?.focus());
  };

  const close = () => {
    panel.hidden = true;
    document.body.classList.remove('ida-account-open');
    setTriggerState(false);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  const showError = (message) => {
    if (!email || !status) return;
    email.setAttribute('aria-invalid', 'true');
    status.textContent = message;
    email.focus();
  };

  const clearError = () => {
    if (!email || !status) return;
    email.removeAttribute('aria-invalid');
    status.textContent = '';
  };

  triggers.forEach((trigger) => trigger.addEventListener('click', open));
  closeButtons.forEach((button) => button.addEventListener('click', close));
  email?.addEventListener('input', clearError);

  document.addEventListener('keydown', (event) => {
    if (panel.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = Array.from(
      panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
    ).filter((node) => node.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    clearError();

    const value = email?.value.trim() || '';
    if (!value || !email.checkValidity()) {
      showError('Inserisci un indirizzo email valido.');
      return;
    }

    const loginUrl = panel.dataset.loginUrl || '/customer_authentication/login';
    try {
      const destination = new URL(loginUrl, window.location.origin);
      destination.searchParams.set('login_hint', value);
      window.location.assign(destination.toString());
    } catch (error) {
      window.location.assign(`/customer_authentication/login?login_hint=${encodeURIComponent(value)}`);
    }
  });
})();
